import {
  Component,
  OnInit,
  ElementRef,
  HostListener,
  ViewChild,
  AfterViewInit,
  Output,
  EventEmitter,
  inject, signal
} from '@angular/core';
import {Observable, Subject} from "rxjs";
import {WebcamImage, WebcamInitError, WebcamUtil} from "ngx-webcam";
import {UtilService} from "library";
import {SalesWorkflowService} from "projects/store/src/app/services/api/v1/sales-workflow.service";
import {HttpStatusCode} from "@angular/common/http";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {ActivatedRoute} from "@angular/router";
import {CustomMessageService, LocalStorageService} from "library";
import { StoreType, LocalStorageKey } from 'projects/store/src/app/enums';


enum Step {
  'camera' = 'camera',
  'image' = 'image',
}

@Component({
  selector: 'app-sales-take-picture',
  templateUrl: './sales-take-picture.component.html',
  styles: [
  ]
})
export class SalesTakePictureComponent implements OnInit, AfterViewInit {
  routesBreadcrumbs = ['VENTAS', 'Autogestión', 'Tomar fotografía'];
  @ViewChild('webcamContainer', { static: false }) webcamContainer!: ElementRef;
  webcamWidth: number = 0;
  webcamHeight: number = 0;
  groupedFields!: any[];
  fieldId!: string
  requestId!: string
  isLoading = false;
  storeData: any;

  private utilService = inject(UtilService);
  private salesWorkflowService = inject(SalesWorkflowService);
  private requestService = inject(RequestService);
  private  readonly route = inject(ActivatedRoute);
  private readonly customMessageService = inject(CustomMessageService);

  readonly categoryCode = this.route.snapshot.params['category_code'];

  data = signal<any>({});


  step = Step.camera;
  private trigger: Subject<void> = new Subject<void>();
  private nextWebcam: Subject<string | boolean> = new Subject<string | boolean>();
  public webcamImage: WebcamImage | null = null;
  // Lista de dispositivos de cámara disponibles
  public availableCameras: MediaDeviceInfo[] = [];
  cameraAccessDenied: boolean = false;
 disabled = signal(false);

  constructor(
    private localStorageService: LocalStorageService
  ) {}

  // ID de la cámara actual
  public currentDeviceId: string | null = null;

  // Opciones de video (resolución, FPS, etc.)
  public videoOptions: MediaTrackConstraints = {
    width: { ideal: 640 },
    height: { ideal: 480 },
    facingMode: 'environment', // 'user' para la frontal
  };

  @Output() nextStepEvent = new EventEmitter();

  ngAfterViewInit() {
    setTimeout(() => {
      this.updateContainerSize();
    });
  }

  updateContainerSize() {
    if (this.webcamContainer) {
      this.webcamWidth = this.webcamContainer.nativeElement.offsetWidth;
      this.webcamHeight = this.webcamWidth / 1.33;
    }
  }

  // Manejar errores de la cámara
  public errors: WebcamInitError[] = [];

  ngOnInit() {
    this.data.set(this.requestService.request);

    this.storeData = this.localStorageService.get(LocalStorageKey.data);
    if(this.storeData && this.storeData.store.type != StoreType.fisica){
      this.onNextStep()
    }else{
      this.requestId = this.route.snapshot.params['request_id'];
      this.utilService.disablePageLoading();
      this.load();
      // Obtener lista de cámaras disponibles
      WebcamUtil.getAvailableVideoInputs().then((devices) => {
        this.availableCameras = devices;
        console.log(this.availableCameras);
        if (devices.length > 0) {
          this.currentDeviceId = devices[0].deviceId; // Seleccionar la primera cámara
        }
      });
    }

  }

  load(){
    this.salesWorkflowService.getAdditionalDataFields(this.salesWorkflowService.currentStep.category_step_id).subscribe({
      next: (step) => {
        if (step.status === HttpStatusCode.Ok){
          this.groupedFields = [...step.body.data.list];
          console.log(this.groupedFields);
        }
      }
    })
  }

  // Activar captura de imagen
  public captureImage(id: string): void {
    this.fieldId = id;
    this.trigger.next();
    this.step = Step.image;
  }

  // Manejar imagen capturada
  public handleImage(image: WebcamImage): void {
    this.webcamImage = image;
  }

  // Manejar errores
  public handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
    if (error.mediaStreamError && error.mediaStreamError.name === 'NotAllowedError') {
      //esto indica que el usuario no dio permiso
        this.cameraAccessDenied = true;
        this.disabled.set(true)
    }else{
      this.cameraAccessDenied = false;
      this.disabled.set(false);
    }
  }


  public switchCamera(deviceIdOrEvent: string | Event): void {
    let deviceId: string;

    if (typeof deviceIdOrEvent === 'string') {
      // Evento de (cameraSwitched) -> directamente el deviceId
      deviceId = deviceIdOrEvent;
    } else {
      // Evento de (change) en <select> -> obtener el valor del select
      deviceId = (deviceIdOrEvent.target as HTMLSelectElement).value;
    }

    this.currentDeviceId = deviceId;
    this.nextWebcam.next(deviceId);
  }

  // Obtener observable del trigger
  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  // Obtener observable para cambiar cámara
  public get nextWebcamObservable(): Observable<string | boolean> {
    return this.nextWebcam.asObservable();
  }

  onGoToStep(step: Step): void {
    this.step = step;
  }

  savePhoto(){
    this.isLoading = true;
    if (!this.webcamImage) {
      this.customMessageService.error('No se ha capturado una imagen.');
      this.isLoading = false;
      return;
    }

    this.requestService.saveAdditionalData(this.requestId, {id: this.fieldId, value: this.webcamImage.imageAsDataUrl}).subscribe({
      next: (resp) => {
        if (resp.status === HttpStatusCode.Ok){
          this.onNextStep();
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.isLoading = false;
      },
      error: (error)=> {
        this.customMessageService.responseNoticeHandler(error);
      }
    })


  }


  onNextStep() {
    this.nextStepEvent.emit();
  }

  protected readonly Step = Step;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.updateContainerSize();
  }
}
